import axios, { AxiosResponse } from "axios";
import {
  throwSylaApiError,
  parseProblemFromBlob,
} from "../errors/throwSylaApiError";

export async function downloadBglXml(
  accountId: string,
  financialYearValue: string,
): Promise<void> {
  let response: AxiosResponse<Blob>;
  try {
    response = await axios.get(`/accounts/${accountId}/get-epi-xml`, {
      params: { financialYearValue },
      responseType: "blob",
    });
  } catch (error) {
    throwSylaApiError(await parseProblemFromBlob(error));
  }

  const link = document.createElement("a");
  link.href = window.URL.createObjectURL(response.data);
  link.setAttribute(
    "download",
    response.headers["content-disposition"]?.match(/filename="(.*)"/)?.at(1) ??
      `Epi Data ${financialYearValue.replace("/", "-")}.xml`,
  );
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  return;
}
